import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Row, Col } from "reactstrap"
import { GatsbyImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import styled from "styled-components"
import { media } from "utils/Media"
import { Link } from "gatsby"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import WPLink from "components/shared/WPLink"

const ContentWrap = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  justify-content: space-between;
  @media ${media.lg} {
    padding: 2rem;
  }
  h3 {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    text-transform: uppercase;
    color: ${props => props.theme.colors.white};
    font-family: ${props => props.theme.font.family.heading};
    //font-style: italic;
    font-weight: 800;
    max-width: 60%;
    font-size: 1.2rem;
    @media ${media.md} {
        font-size: 1.5rem;
      }
    @media ${media.lg} {
        font-size: ${props => props.theme.font.size.xl};
      }
    span {
      display: block;
      font-weight: 500;
      width: 100%;
      font-size: ${props => props.theme.font.size.base};
      @media ${media.lg} {
        font-size: ${props => props.theme.font.size.md};
      }
      
    }
  }
  .btn {
    border-bottom: solid 2px ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
    font-size: 1rem;
    font-family: ${props => props.theme.font.family.heading};
    letter-spacing: .5px;
    text-transform: uppercase;
    font-weight: 800;
  
    @media ${media.md} {
        background: ${props => props.theme.colors.secondary};
        border: 0;
        display: inline-block;
        text-transform: uppercase;
        text-decoration: none !important;
        white-space: nowrap;
        font-size: .85rem;
        font-family: ${props => props.theme.font.family.body};
        font-weight: ${props => props.theme.font.weight.semiBold};
        //font-style: italic;
        /* font-weight: ${props => props.theme.font.family.bold}; */
        color: ${props => props.theme.colors.black};
        border: 3px solid ${props => props.theme.colors.secondary};
        line-height: 1;
        position: relative;
        padding: .85rem 1rem;
        text-align: center;
        transition: all .2s ease-in-out;
        &:hover, &:active {
          background: #dda200;
          border: solid 3px #dda200;
        }
      
    }
    @media ${media.lg} {
      font-size: ${props => props.theme.font.size.base};
    }
  }
`

const PlayerListing = (props) => {	
	const data = useStaticQuery(graphql`
	{
		allWpPlayer(
			limit: 1000, filter: {status: {eq: "publish"}}
		) {
			edges {
				node {
					uri
					title
					date
					acfPlayers {
            page
						featuredImage {
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 706, quality: 85, placeholder: NONE, layout: CONSTRAINED)
								}
							}
						}
            subtitle
					}
				}
			}
		}
	}`)

	const players = data.allWpPlayer?.edges

  const PlayerDetails = (props) => {
    const  { node } = props
    return(
      <>
        <GatsbyImage
          image={node.acfPlayers?.featuredImage?.localFile?.childImageSharp?.gatsbyImageData}
          alt={node.acfPlayers?.featuredImage?.altText}
          className="background-gradient"
        />
        <ContentWrap>
          <div>
            <h3>
              {node.title}
              {node.acfPlayers.subtitle &&
                <span>{node.acfPlayers.subtitle}</span>
              }
            </h3>
          </div>
          {node.acfPlayers.page &&
            <div className="btn">
              Read bio
            </div>
          }
        </ContentWrap>
      </>
    )
  }

	return (
		<ContainerMax className="py-4">
			<ContentMax>
        <Row>
          {players && players.map(({node}, i) => {
            return (
              <Col xs={12} md={6} key={i} className="pb-4">
                {node.acfPlayers.page ? (
                  <Link to={node.uri} className="position-relative d-block">
                    <PlayerDetails node={node} />
                  </Link>
                ) : (
                  <div className="position-relative d-block">
                    <PlayerDetails node={node} />
                  </div>
                )}
              </Col>
            )
          })}
        </Row>
			</ContentMax>
		</ContainerMax> 
	)
}

export default PlayerListing